import Vue from "vue";
import App from "./App.vue";
import router from "./router";

// BOOTSTRAP
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

// MOMENT
import moment from "moment";
Vue.prototype.$moment = moment;

// LODASH
import lodash from "lodash";
Vue.prototype.$_ = lodash;

// SECURE RANDOM STRINGS
import randomString from "secure-random-string";
Vue.prototype.$randomString = randomString;

// TIPPY
import VueTippy, { TippyComponent } from "vue-tippy";
Vue.use(VueTippy);
Vue.component("tippy", TippyComponent);

// CHAT
//import Chat from "@/assets/vue-beautiful-chat/vue-beautiful-chat.umd.min.js";
import Chat from "vue-beautiful-chat";
Vue.use(Chat);

// CUSTOM COMPONENTS
import DialogInfo from "@/components/DialogInfo";
Vue.component("DialogInfo", DialogInfo);
import TopquizTippy from "@/components/TopquizTippy";
Vue.component("TopquizTippy", TopquizTippy);

var isDevMode =
  window.webpackHotUpdate ||
  (process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    typeof console !== "undefined");

import settingsProduction from "../public/settings.js";
import settingsDevelopment from "./assets/settings.js";
if (isDevMode) {
  Vue.prototype.$settings = settingsDevelopment;
} else {
  Vue.prototype.$settings = settingsProduction;
}

import TopQuizSocket from "./assets/topquiz.js";
var tq = new TopQuizSocket(Vue.prototype.$settings, randomString);
Vue.prototype.$topquiz = tq;

import constants from "./assets/constants.js";
Vue.prototype.$tqConstants = constants;

Vue.prototype.$noop = () => {};

import "./assets/css/topquiz-vue.scss";
import store from "./store";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
